import { render, staticRenderFns } from "./MontagemCargaDetalhes.vue?vue&type=template&id=dd97fde8"
import script from "./MontagemCargaDetalhes.vue?vue&type=script&lang=js"
export * from "./MontagemCargaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports